exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6e8f4b16] .el-card__header {\n  background: #f5f7fa;\n}\n.card-header[data-v-6e8f4b16] {\n  height: 40px;\n  line-height: 40px;\n}\n.container .subtitle[data-v-6e8f4b16] {\n  margin-top: 15px;\n  font-size: 12px;\n  color: #909399;\n}\n.container .content[data-v-6e8f4b16] {\n  padding: 20px 30px 0 30px;\n}\n", ""]);

// exports
